import React, { useState } from 'react'
// import {TiTick}from "react-icons/ti"
import v from '../assets/v.png'
import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';
import Step5 from './Step5';
import SuccessScreen from './SuccessScreen';
import { generatePDF1 } from '../util/convertPDF';
import axios from 'axios';
import { useParams,useNavigate } from 'react-router-dom';

const ProgressBar = () => {
      const navigate = useNavigate();
    const steps = [1, 2, 3, 4,5]
const { sessionId } = useParams();
    const [formData, setFormData] = useState({
        q1: null,
        q2: null,
        q3: null,
        q3Age: null,
        q4: null,
        q4Diagnosis: null,
        q5: "",
        q5Other: "",
        q6: null,
        q7: "",
        q7Other: "",
        q8: null,
        q9: "",
    })
    const [currentStep, setCurrentStep] = useState(0);
    const totalSteps = 4; // Total number of steps in the form

    const handleNext = () => {
        console.log(formData)
        setCurrentStep(currentStep + 1);

    };

    // const handlePrevious = () => {
    //     setCurrentStep(currentStep - 1);
    // };

    // const calculateProgress = () => {
    //     return ((currentStep - 1) / totalSteps) * 100;
    // };
    const handleSubmit = async () => {

        const pdf = generatePDF1(formData)
        const pdfBlob = pdf.output('blob');
        const formData1 = new FormData();
        formData1.append('img_questionnaire ', pdfBlob, `consent_form${sessionId}.pdf`);
        formData1.append('questionnaireDetails  ', JSON.stringify({   q1: formData.q1,
        q2: formData.q2,
        q3: formData.q3,
        q3Age: formData.q3Age,
        q4: formData.q4,
        q4Diagnosis: formData.q4Diagnosis,
        q5: formData.q5,
        q6: formData.q6,
        q7: formData.q7,
        q8: formData.q8,
        q9: formData.q9}));

        try {
            const response = await axios.post(`/dashboard/questionnaire_document/${sessionId}`, formData1, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            });
            if (response.status == 200)
            {navigate(`/Gallery/${sessionId}`)}
            console.log("הקובץ נשלח בהצלחה לשרת", response.data);
            return true
        } catch (error) {
            console.error("שגיאה בשליחת הקובץ:", error);
            return false
        }
    }
    return (
        <div className='w-full min-h-[90vh] px-7 py-4 flex flex-col justify-between '>
            <div className='w-full'>{currentStep != 4 && <div className='w-full mb-10 flex justify-between '>
                {steps.map((step, index) => (
                    <div key={index} className={` flex justify-center items-center relative w-full before:content-[''] ${currentStep > index - 1 ? "before:bg-PraimeryBlue" : "before:bg-Grey100"}  before:w-full before:h-[3px] before:absolute before:right-1/2 before:top-1/2  before:-translate-y-1/2  before:first:hidden`} >
                        <div className={`${index <= currentStep ? "bg-PraimeryBlue text-white" : "text-Grey300 bg-Grey100"}  w-10 h-10 flex justify-center items-center rounded-full relative z-10`}>{index < currentStep ? <img src={v} /> : step}</div>
                    </div>))}
            </div>}

                {/* <button onClick={handlePrevious}>back</button> */}
                {currentStep == 0 && <Step1 formData={formData} setFormData={setFormData}></Step1>}
                {currentStep == 1 && <Step2 formData={formData} setFormData={setFormData}></Step2>}
                {currentStep == 2 && <Step3 formData={formData} setFormData={setFormData}></Step3>}
                {currentStep == 3 && <Step4 formData={formData} setFormData={setFormData}></Step4>}
                {currentStep == 4 && <Step5 formData={formData} setFormData={setFormData}></Step5>}
                {/* {currentStep == 4 && <SuccessScreen></SuccessScreen>} */}
            </div>
            {currentStep != 5 && <button disabled={(currentStep == 0 && (formData.q1 == null || formData.q2 == null)) || (currentStep == 1 && (formData.q3 == null || formData.q4 == null)) || (currentStep == 2 && (formData.q5 == ""|| formData.q6 == null)) || (currentStep == 3 && (formData.q7 == "")||(formData.q8 == ""))||(currentStep == 4 && (formData.q9 == ""))} className='w-full px-5 py-3 bg-PraimeryBlue rounded-lg mt-3 text-white text-lg font-bold disabled:bg-Grey300' onClick={currentStep == steps.length - 1 ? () => {
            //   if (handleSubmit())
            //     {  handleNext()}
            handleSubmit()
            } : handleNext}>{currentStep == steps.length - 1 ? "סיים ועבור לגלריה" : "המשך"}</button>}
        </div>
    );
}




// <div className="max-w-xl mx-auto mt-8 p-6 border rounded shadow-lg">
//         {/* Form Steps */}
//         <div className="mb-4">
//           <div className="relative h-3 rounded bg-Grey300">
//             <div
//               className="absolute top-0 left-0 h-3 rounded bg-MidBlue"
//               style={{ width: `${calculateProgress()}%` }}
//             ></div>
//           </div>
//           <div className="flex justify-between mt-2">
//             <span>Step {currentStep} of {totalSteps}</span>
//             <div>
//               {currentStep > 1 && (
//                 <button onClick={handlePrevious} className="btn btn-secondary mr-4">Previous</button>
//               )}
//               {currentStep < totalSteps ? (
//                 <button onClick={handleNext} className="btn btn-primary">Next</button>
//               ) : (
//                 <button className="btn btn-success">Submit</button>
//               )}
//             </div>
//           </div>
//         </div>

//         {/* Form Content */}
//         {currentStep === 1 && (
//           <div>
//             <h2 className="text-xl font-bold mb-4">Step 1: Personal Information</h2>
//             {/* Your form fields for step 1 */}
//           </div>
//         )}
//         {currentStep === 2 && (
//           <div>
//             <h2 className="text-xl font-bold mb-4">Step 2: Address Information</h2>
//             {/* Your form fields for step 2 */}
//           </div>
//         )}
//         {currentStep === 3 && (
//           <div>
//             <h2 className="text-xl font-bold mb-4">Step 3: Confirmation</h2>
//             {/* Your form fields for step 3 */}
//           </div>
//         )}
//       </div>

export default ProgressBar



